module.exports = __webpack_public_path__ + "static/img/jump-pad_256.e29b562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jump-pad_256.png
// module id = skiq
// module chunks = 0